import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFire,
  faExclamationTriangle,
  faBan,
} from "@fortawesome/free-solid-svg-icons";

type PiStatusBadgeWithTrendProps = {
  pistatus: number; // 0 = Ignore, 1 = Watchlist, 2 = Good to Enter
  trendBadge?: number; // 0 = Broken, 1 = Weak, 2 = Strong
};

const PiStatusBadgeWithTrend: React.FC<PiStatusBadgeWithTrendProps> = ({
  pistatus,
  trendBadge = 0,
}) => {
  let bgColor = "bg-red-500/80";
  let textColor = "text-white";
  let text = "Ignore";

  if (pistatus === 2) {
    text = "Good to Enter";
    bgColor = "bg-darkMode-green/20";
    textColor = "text-darkMode-green";
  } else if (pistatus === 1) {
    text = "Watchlist";
    bgColor = "bg-yellow-500/30";
    textColor = "text-yellow-400";
  }

  let trendIcon = faBan;
  if (trendBadge === 2) trendIcon = faFire;
  else if (trendBadge === 1) trendIcon = faExclamationTriangle;

  return (
    <div className="flex items-center justify-center w-full px-1">
      <div
        className={`flex items-center justify-center rounded-full text-xs font-semibold border-0 px-2 py-0.5 text-center whitespace-nowrap min-w-[70px] ${bgColor} ${textColor}`}
      >
        <span className="flex items-center">
          {text}
          {/* <FontAwesomeIcon
            icon={trendIcon}
            className="ml-2 text-xs sm:text-sm md:text-base"
          /> */}
        </span>
      </div>
    </div>
  );
};

export default PiStatusBadgeWithTrend;
